import React from "react";

interface CustomInputProps {
    label?: string;
    name: string;
    placeholder?: string;
    value: string;
    type?: "text" | "date" | "time" | "textarea";
    onChange: (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
    error?: string;
    icon?: string;
    min?: string;
    max?: string;
    required?: boolean;
    disabled?: boolean;
}

const Input: React.FC<CustomInputProps> = ({
    label,
    name,
    placeholder,
    value,
    type = "text",
    onChange,
    error,
    icon,
    min,
    max,
    required,
    disabled = false,
}) => {
    const isTextarea = type === "textarea";

    return (
        <div style={{ width: "100%" }}>
            {label && (
                <label
                    style={{
                        display: "block",
                        marginBottom: "8px",
                        color: "#101828",
                        fontSize: "14px",
                        fontWeight: 500,
                    }}
                    className="!text-sm"
                >
                    {label}{required && <span className="text-red-500">*</span>}
                </label>
            )}

            {/* WRAPPER */}
            <div
                style={{
                    position: "relative",
                    width: "100%",
                    background: "#F3F3F5",
                    borderRadius: "8px",
                    // border: "1px solid #E8E8E8",
                    display: isTextarea ? "block" : "flex",
                    alignItems: "center",
                    height: isTextarea ? "auto" : "50px",
                    padding: "0px",
                    margin: "0px",
                    border: error ? "1px solid #EF4444" : "none",
                }}
            >
                {/* ICON */}
                {icon && (
                    <img
                        src={icon}
                        alt="icon"
                        style={{
                            position: "absolute",
                            left: "14px",
                            top: "50%",
                            transform: "translateY(-50%)",
                            width: "16px",
                            height: "16px",
                            cursor: type === "date" ? "pointer" : "default",
                        }}
                        onClick={() => {
                            if ((type === "date" || type === "time") && !disabled) {
                                const el = document.getElementById(name) as HTMLInputElement;
                                el?.showPicker?.();
                            }
                        }}

                    />
                )}

                {/* TEXTAREA */}
                {isTextarea ? (
                    <textarea
                        id={name}
                        name={name}
                        placeholder={placeholder}
                        value={value}
                        onChange={onChange}
                        disabled={disabled}
                        style={{
                            width: "100%",
                            border: "none",
                            outline: "none",
                            boxShadow: "none",
                            background: "transparent",
                            fontSize: "14px",
                            color: "#717182",
                            paddingLeft: icon ? "48px" : "14px",
                            paddingRight: "14px",


                        }}
                    />
                ) : (
                    /* NORMAL INPUT */
                    <input
                        id={name}
                        type={type}
                        name={name}
                        placeholder={placeholder}
                        value={value}
                        disabled={disabled}
                        min={min}
                        max={max}
                        onChange={onChange}
                        onClick={(e) => {
                            if ((type === "date" || type === "time") && !disabled) {
                                (e.currentTarget as HTMLInputElement).showPicker?.();
                            }
                        }}
                        className={type === "date" ? "no-date-icon" : type === "time" ? "no-time-icon" : ""}
                        style={{
                            width: "100%",
                            height: "100%",
                            border: "none",
                            outline: "none",
                            boxShadow: "none",
                            background: "transparent",
                            fontSize: "14px",
                            color: "#717182",
                            paddingLeft: icon ? "48px" : "14px",
                            paddingRight: "14px",
                            cursor: disabled ? "not-allowed" : (type === "date" ? "pointer" : "text"),

                            // 🔥 KILL FOCUS BORDER
                            WebkitTapHighlightColor: "transparent",
                        }}
                    />
                )}
            </div>

            {/* ERROR */}
            {error && (
                <p
                    style={{
                        color: "#EF4444",
                        fontSize: "13px",
                        marginTop: "4px",
                    }}
                >
                    {error}
                </p>
            )}
        </div>
    );
};

export default Input;